import { useWidgetData } from '../useWidgetData'

import { TopCourtReportModel } from '../../../types/court/court'
import { ReportInterval } from '../../../types/report/report'
import { createReportQuery } from '../../../utils/reportUtils'

export const useTopCourtsWidget = (interval: ReportInterval) =>
  useWidgetData<TopCourtReportModel[]>(
    `top-courts?${createReportQuery(interval)}`
  )
